import Vue from "vue";
import ApiService from "../../../../services/api";
import moment from "moment";
import { bus } from "../../../../main";
import { mapGetters } from "vuex";
import helpers from "../../../../shared/fleetbox-helpers";

export default {
	data: function() {
		return {
			reportName: "",

			//#region filters
			filters: [
				{
					id: "timerange",
					items: [],
					value: {
						period: "0",
						startRange: moment(),
						endRange: moment()
					}
				},
				{
					id: "divisions",
					items: [],
					value: []
				},
				{
					id: "groups",
					items: [],
					value: []
				},
				{
					id: "vehicles",
					items: [],
					value: []
				},
				{
					id: "drivers",
					items: [],
					value: []
				}
			],
			//#endregion filters

			//#region total timings
			totalTimingTitle: "Tempo di viaggio totale",
			driveIdleTime: [
				{
					name: "Tempo di viaggio totale",
					field: "value",
					//color: "#26958f",
					labels: {
						visible: true,
						template: this.getStackTimeFromString,
						background: "none",
						font: "10px montserrat-light"
					}
				}
				// ,{
				// 	name: "Tempo di inattività",
				// 	field: "idle",
				// 	color: "#fcb612",
				// 	labels: {
				// 		visible: true,
				// 		template: this.getStackTimeFromString,
				// 		background: "none"
				// 	}
				// }
			],
			driveIdleTimeData: [],
			driveIdleTimeTooltip: {
				visible: true,
				template: this.getDriveIdleTooltip
			},
			driveIdleTimeCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			driveIdleTimeValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						content: this.getTimeFromString,
						visible: false
					}
				}
			],

			driveIdleTimeChartIndex: 0,
			//#endregion total timings

			//#region percentage day utilization
			percentageDailyTime: [
				{
					name: "utilizzo per giorno",
					field: "drive",
					color: "#518f8f",
					labels: {
						visible: true,
						template: this.getStackAndPercentageTimeFromString,
						background: "none",
						font: "10px montserrat-light"
					}
				}
				// {
				// 	name: "Tempi di inattività",
				// 	field: "idle",
				// 	color: "#fcb612",
				// 	labels: {
				// 		visible: true,
				// 		template: this.getStackAndPercentageTimeFromString
				// 	}
				// }
			],
			percentageDailyData: [],
			percentageDailyTooltip: {
				visible: true,
				template: this.getPercentageDailyTooltip
			},
			percentageDailyCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			percentageDailyValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						content: this.getTimeFromString,
						visible: false
					}
				}
			],

			percentageDailyTimeChartIndex: 0,
			//#endregion

			//#region modal driving time
			drivingTimingsPdfOptions: {
				landscape: true,
				fileName: "tempo_di_viaggio_totale",
				title: "TEMPO DI VIAGGIO TOTALE"
			},
			drivingTimingsModalShow: false,
			drivingTimingsTitle: "TEMPO DI VIAGGIO TOTALE",

			drivingTimingsValueAxisModal: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "ORE",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						content: this.getTimeFromString,
						visible: true,
						font: "13px montserrat-light"
					}
				}
			],

			drivingTimingsLegend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						for (var i = 0; i < 3; i++) {
							var color = e.series.data[i].color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var name = "";
							if (e.series.data[i].valueTime) {
								name = "Tempo di guida";
							} else if (e.series.data[i].idleTime) {
								name = "Tempo di inattività";
							} else {
								name = "Tempo totale di utilizzo";
							}
							var label = new kendo.drawing.Text(name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light !important"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label, rectangle);
							layout.reflow();
						}

						return layout;
					}
				}
			},

			drivingTimingsChartModalIndex: 0,
			//#endregion

			//#region modal utlization time
			utilizationTimingsPdfOptions: {
				landscape: true,
				fileName: "percentuale_utilizzo_per_giorno",
				title: "PERCENTUALE DI UTILIZZO PER GIORNO"
			},
			utilizationTimingsModalShow: false,
			utilizationTimingsTitle: "PERCENTUALE UTILIZZO PER GIORNO",

			utilizationTimingsValueAxisModal: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "ORE",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						content: this.getTimeFromString,
						visible: true,
						font: "13px montserrat-light"
					}
				}
			],

			utilizationTimingsLegend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var color = e.series.color; //e.options.markers.background;
						var labelColor = e.options.labels.color;

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
							fill: {
								color: labelColor
							},
							font: "12px 'Montserrat Light', montserrat-light !important"
						});

						var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
						var rectangle = new kendo.drawing.Rect(rectGeom, {
							fill: { color: "none" },
							stroke: { color: "none" }
						});

						layout.append(marker, label, rectangle);
						layout.reflow();

						return layout;
					}
				}
			},

			utilizationTimingsChartModalIndex: 0,
			//#endregion

			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles"

			
		};
	},
	created() {
		var self = this;
		//#region filters
		this.filters[0].value.startRange = moment()
			.add(-7, "days")
			.startOf("day");
		this.filters[0].value.endRange = moment().endOf("day");
		//#endregion filters

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
		}

		bus.$emit("show-spinner-loading");

		helpers.getReportName().then(res => {
			if (res) {
				var report = res.find(item => {
					return item.id == 200;
				});

				if (report) {
					self.reportName = report.name;
				} else {
					self.reportName = "UTILIZZO";
				}
			}
		});
	},
	mounted() {
		this.getData();
	},
	methods: {
		//#region NO MODAL
		getDriveIdleTooltip(e) {
			var timeFromSeconds = this.$options.filters.timeFromSecondsToString(e.value);
			return `${e.category} dal ${e.dataItem.from} al ${e.dataItem.to}: ${timeFromSeconds}`;
		},
		getPercentageDailyTooltip(e) {
			var timeFromSeconds = this.$options.filters.timeFromSecondsToString(e.value);
			return `${e.series.name} del ${e.dataItem.day}: ${timeFromSeconds} - ${e.dataItem.percentageDriveTime} %`;
		},
		getTimeFromString(e) {
			return this.$options.filters.timeFromSecondsToString(e.value);
		},
		getStackTimeFromString(e) {
			return this.$options.filters.timeFromSecondsToString(e.stackValue);
		},
		getStackAndPercentageTimeFromString(e) {
			return `${this.$options.filters.timeFromSecondsToString(e.stackValue)}\n${e.dataItem.percentageDriveTime} %`;
		},
		getData: function() {
			var self = this;

			var data = this.getRequestData();

			bus.$emit("show-spinner-loading");

			ApiService.getTotalTimings(data).then(res => {
				self.setTotalTimingsData(res);

				bus.$emit("hide-spinner-loading");
			});

			ApiService.getPercentageDailyTimings(data).then(res => {
				self.setPercentageDailyData(res);
			});
		},
		getRequestData() {
			var self = this;
			var data = {};

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "divisions":
							if (element.value) {
								data["division"] = element.value;
							}
							break;
						case "groups":
							if (element.value && element.value != -1) {
								data["group"] = element.value;
							}
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								for (var j = 0; j < element.value.length; j++) {
									var field = `${self.vehicleIdFilterFieldFormatted}[${j}]`;
									var value = element.value[j];

									data[field] = value;
								}
							}
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;

						default:
							break;
					}
				});
			}

			return data;
		},
		setTotalTimingsData(data) {
			var self = this;
			if (data && data.values) {
				var item = data;
				self.driveIdleTimeData = [];
				var startDate = self.$options.filters.dateToString(item.from);
				var endDate = self.$options.filters.dateToString(item.to);

				// var isToday = false;
				// if (item.to) {
				// 	var tt = moment(item.to);
				// 	isToday =
				// 		moment()
				// 			.startOf("day")
				// 			.diff(tt.startOf("day"), "days") == 0;

				// 	if (isToday) {
				// 		endDate = self.$options.filters.dateToString(moment(item.to).add(-1, "days"));
				// 	}
				// }

				self.totalTimingTitle = `Tempo di viaggio totale dal ${startDate} al ${endDate}`;
				self.drivingTimingsPdfOptions.fileName = helpers.chartPdffileName(this, this.reportName + "_Tempo_di_viaggio_totale", moment(startDate, "DD/MM/YYYY"), moment(endDate, "DD/MM/YYYY"));
				self.drivingTimingsTitle = self.totalTimingTitle.toUpperCase();
				self.utilizationTimingsTitle = `% utilizzo per giorno (settimanale) dal ${startDate} al ${endDate}`.toUpperCase();
				self.utilizationTimingsPdfOptions.fileName = helpers.chartPdffileName(this, this.reportName + "_%_utilizzo_per_giorno", moment(startDate, "DD/MM/YYYY"), moment(endDate, "DD/MM/YYYY"));
				self.driveIdleTimeCategoryAxis.categories = [];
				self.driveIdleTimeCategoryAxis.categories.push(`TEMPO DI GUIDA`);
				self.driveIdleTimeCategoryAxis.categories.push(`TEMPO DI INATTIVITA'`);
				self.driveIdleTimeCategoryAxis.categories.push(`TEMPO TOTALE DI UTILIZZO`);

				var totalTime = item.drive_time + item.idle_time;
				self.driveIdleTimeData.push({
					from: self.$options.filters.dateToString(item.from),
					to: self.$options.filters.dateToString(item.to),
					value: parseInt(item.values.drive),
					//idle: parseInt(item.values.idle),
					valueTime: true,
					idleTime: false,
					totalTime: false,
					color: "#15ac5c"
				});
				self.driveIdleTimeData.push({
					from: self.$options.filters.dateToString(item.from),
					to: self.$options.filters.dateToString(item.to),
					//drive: parseInt(item.values.drive),
					value: parseInt(item.values.idle),
					valueTime: false,
					idleTime: true,
					totalTime: false,
					color: "#ff9900"
				});
				self.driveIdleTimeData.push({
					from: self.$options.filters.dateToString(item.from),
					to: self.$options.filters.dateToString(item.to),
					//drive: parseInt(item.values.drive),
					value: parseInt(item.values.trip),
					valueTime: false,
					idleTime: false,
					totalTime: true,
					color: "#236991"
				});

				self.driveIdleTimeChartIndex++;

				bus.$emit("hide-spinner-loading");
			}
		},

		setPercentageDailyData(data) {
			var self = this;
			if (data && data.values) {
				var item = data;
				self.percentageDailyData = [];
				self.percentageDailyCategoryAxis.categories = [];

				var days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
				var daysIt = ["LUNEDI'", "MARTEDI'", "MERCOLEDI'", "GIOVEDI'", "VENERDI'", "SABATO", "DOMENICA"];

				//calculate total drive and idle time
				var totalDriveTime = 0;
				data.forEach(d => {
					if (d.values) {
						totalDriveTime += d.values.drive;
					}
				});

				var totalPercentageValueCalculated = 0;

				for (var i = 0; i < days.length; i++) {
					var day = days[i];
					var item = data.find(dd => {
						return dd.day == day;
					});

					self.percentageDailyCategoryAxis.categories.push(`${daysIt[i]}`);

					if (item) {
						//var totalTime = item.values.drive + item.values.idle;
						var percentageDriveTime = 0;
						if (totalDriveTime > 0) {
							percentageDriveTime = Math.round((100 * item.values.drive) / totalDriveTime);
							totalPercentageValueCalculated += percentageDriveTime;
						}

						self.percentageDailyData.push({
							day: daysIt[i],
							drive: parseInt(item.values.drive),
							//idle: parseInt(item.values.idle),
							valueTime: self.$options.filters.timeFromSecondsToString(item.drive),
							percentageDriveTime: percentageDriveTime
							//idleTime: self.$options.filters.timeFromSecondsToString(item.idle),
							//totalTime: self.$options.filters.timeFromSecondsToString(totalTime)
						});
					} else {
						self.percentageDailyData.push({
							day: daysIt[i],
							drive: 0,
							//idle: parseInt(item.values.idle),
							valueTime: "00:00:00",
							percentageDriveTime: 0
							//idleTime: self.$options.filters.timeFromSecondsToString(item.idle),
							//totalTime: self.$options.filters.timeFromSecondsToString(totalTime)
						});
					}
				}

				//Adjust percentage value
				var adjustValue = 100 - totalPercentageValueCalculated;
				if (adjustValue != 0) {
					var pddToAdjust = self.percentageDailyData.filter(function(item) {
						return item.percentageDriveTime > 0;
					});
					if (adjustValue > 0) {
						var pddToAdjustOrdered = self._.sortBy(pddToAdjust, function(item) {
							return item.percentageDriveTime;
						});

						for (var i = 0; i < pddToAdjustOrdered.length; i++) {
							pddToAdjustOrdered[i].percentageDriveTime += 1;
							adjustValue--;

							if (adjustValue == 0) break;
						}
					}
					else {
						var pddToAdjustOrdered = self._.sortBy(pddToAdjust, function(item) {
							return -item.percentageDriveTime;
						});

						for (var i = 0; i < pddToAdjustOrdered.length; i++) {
							pddToAdjustOrdered[i].percentageDriveTime -= 1;
							adjustValue++;

							if (adjustValue == 0) break;
						}
					}
				}

				self.percentageDailyTimeChartIndex++;
			}
		},

		//#region filters events
		onFilterApplyClick() {
			this.getData();
		},
		onFilterResetClick() {
			this.setDefaultFilters();
			this.onFilterApplyClick();
		},
		onFilterTimerangeChange(newValue) {
			var timeRangeFilter = this.filters.find(item => {
				return item.id == "timerange";
			});
			if (timeRangeFilter) {
				timeRangeFilter.value.startRange = moment(newValue.startDate);
				timeRangeFilter.value.endRange = moment(newValue.endDate);
			}

			//this.getData();
		},
		onFilterDivisionChange(newValue) {
			var divisionFilter = this.filters.find(item => {
				return item.id == "divisions";
			});
			if (divisionFilter) {
				Vue.set(divisionFilter, "value", newValue);
			}
			//this.getData();
		},
		onFilterGroupChange(newValue) {
			var groupFilter = this.filters.find(item => {
				return item.id == "groups";
			});
			if (groupFilter) {
				Vue.set(groupFilter, "value", newValue);
			}
			//this.getData();
		},
		onFilterDriverChange(newValue) {
			var driverFilter = this.filters.find(item => {
				return item.id == "drivers";
			});
			if (driverFilter) {
				Vue.set(driverFilter, "value", newValue);
			}
			//this.getData();
		},
		onFilterPlateChange(newValue) {
			var vehiclesFilter = this.filters.find(item => {
				return item.id == "vehicles";
			});
			if (vehiclesFilter) {
				Vue.set(vehiclesFilter, "value", newValue);
			}
			//this.getData();
		},
		setDefaultFilters() {
			this.filters[0].value.period = "0";
			this.filters[0].value.startRange = moment()
				.add(-7, "days")
				.startOf("day");
			this.filters[0].value.endRange = moment().endOf("day");

			for (var i = 1; i < this.filters.length; i++) {
				var flt = this.filters[i];

				Vue.set(flt, "value", []);
			}
		},
		//#endregion filters events
		//#endregion NO MODAL

		//#region MODAL
		timingsClickHandler(type) {
			var self = this;
			if (type == "d") {
				self.drivingTimingsModalShow = true;
				setTimeout(() => {
					self.drivingTimingsChartModalIndex++;
				}, 200);
			} else {
				self.utilizationTimingsModalShow = true;
				setTimeout(() => {
					self.utilizationTimingsChartModalIndex++;
				}, 200);
			}
		},
		getTimeFromString(e) {
			return this.$options.filters.timeFromSecondsToString(e.value);
		},
		exportAsPdf(type) {
			var container = $("<div />")
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 600
				})
				.appendTo("body");

			function cleanup() {
				container.getKendoChart().destroy();
				container.remove();
			}

			if (type == "d") {
				this.createDririvngChart(container, {
					transitions: false,

					render: function(e) {
						e.sender.saveAsPDF();
						setTimeout(cleanup, 500);
					}
				});
			} else {
				this.createUtilizationChart(container, {
					transitions: false,

					render: function(e) {
						e.sender.saveAsPDF();
						setTimeout(cleanup, 500);
					}
				});
			}
		},
		exportAsXlsx(report, type) {
			var self = this;

			var data = this.getRequestData();
			if (type == "csv") data["format"] = "csv";
			if (report == "d") {
				ApiService.exportChartXlsx("timings/total", data).then(res => {
					let blob = self.$options.filters.b64toBlob(res.data.fileContents);
					let link = document.createElement("a");
					var url = URL.createObjectURL(blob);
					link.setAttribute("href", url);
					link.setAttribute("download", res.data.fileDownloadName || `tempo_di_viaggio_totale.${type}`);
					link.style = "visibility:hidden";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			} else {
				ApiService.exportChartXlsx("timings/dayofweek", data).then(res => {
					let blob = self.$options.filters.b64toBlob(res.data.fileContents);
					let link = document.createElement("a");
					var url = URL.createObjectURL(blob);
					link.setAttribute("href", url);
					link.setAttribute("download", res.data.fileDownloadName || `percentuale_utilizzo_per_giorno.${type}`);
					link.style = "visibility:hidden";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			}
		},

		//#region Create chart for export
		createDririvngChart(container, exportOptions) {
			var self = this;

			var options = {
				pdf: self.drivingTimingsPdfOptions,
				theme: "metro",
				title: {
					text: self.drivingTimingsTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					visible: true,
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							for (var i = 0; i < 3; i++) {
								var color = e.series.data[i].color; //e.options.markers.background;
								var labelColor = e.options.labels.color;

								var marker = new kendo.drawing.Path({
									fill: {
										color: color
									},
									stroke: {
										color: color
									}
								})
									.moveTo(0, 0)
									.lineTo(0, 10)
									.lineTo(30, 10)
									.lineTo(30, 0)
									.close();

								var name = "";
								if (e.series.data[i].valueTime) {
									name = "Tempo di guida";
								} else if (e.series.data[i].idleTime) {
									name = "Tempo di inattività";
								} else {
									name = "Tempo totale di utilizzo";
								}
								var label = new kendo.drawing.Text(name.toUpperCase(), [0, 0], {
									fill: {
										color: labelColor
									},
									font: "12px 'Montserrat Light', montserrat-light"
								});

								var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
								var rectangle = new kendo.drawing.Rect(rectGeom, {
									fill: { color: "none" },
									stroke: { color: "none" }
								});

								layout.append(marker, label, rectangle);
								layout.reflow();
							}

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.driveIdleTimeData
				},
				series: self.driveIdleTime,
				valueAxis: self.drivingTimingsValueAxisModal,
				categoryAxis: {
					categories: self.driveIdleTimeCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			options = $.extend(true, options, exportOptions);
			container.kendoChart(options);
		},

		createUtilizationChart(container, exportOptions) {
			var self = this;

			var options = {
				pdf: self.utilizationTimingsPdfOptions,
				theme: "metro",
				title: {
					text: self.utilizationTimingsTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					visible: true,
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label, rectangle);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.percentageDailyData
				},
				series: self.percentageDailyTime,
				valueAxis: self.utilizationTimingsValueAxisModal,
				categoryAxis: {
					categories: self.percentageDailyCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			options = $.extend(true, options, exportOptions);
			container.kendoChart(options);
		}
		//#endregion create chart for export
		//#endregion MODAL
	},
	computed: {
		...mapGetters(["settings"])
	}
};
